import "./testimonials.scss";

export default function Testimonials() {
  const data = [
    {
      
      id: 1,
      name: "Sumit Verma",
      title: "South Indian Bank",
      img:
        "assets/sumit.jpg",
      icon: "assets/twitter.png",
      desc:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    },
    {
      id: 2,
      name: "Sahil Karia",
      title: "Freelance Product Designer",
      img:
        "https://www.99corporates.com/DirectorImages/07320845.jpg",
      icon: "assets/youtube.png",
      desc:
        "Satyam was always open to taking up tasks and researching about technologies that were new to him. Happy to work with him again in the future.",
      featured: true,
    },
    {
      id: 3, 
      name: "Hanif Shaikh",
      title: "DataFusion Solutions Pvt. Ltd.",
      img:
        "assets/hanif.jpg",
      icon: "assets/linkedin.png",
      desc:
        "Working with Satyam was great. His efforts in contributing towards daily design works was amazing. ",
    },
  ];
  return (
    <div className="testimonials" id="testimonials">
      <h1>Testimonials</h1>
      <div className="container">
        {data.map((d) => (
          <div className={d.featured ? "card featured" : "card"}>
            <div className="top">
              <img src="assets/right-arrow.png" className="left" alt="" />
              <img
                className="user"
                src={d.img}
                alt=""
              />
              <img className="right" src={d.icon} alt="" />
            </div>
            <div className="center">
              {d.desc}
            </div>
            <div className="bottom">
              <h3>{d.name}</h3>
              <h4>{d.title}</h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
